import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filter out strings in a string array from a another array containing strings.
 *
 * Usage:
 * value | stringFilter:string[]
 *
 * Example:
 *
 * ['hello', 'nice'] | stringFilter:['hello']
 *
 * Outputs: ['nice']
 */
@Pipe({
	name: 'stringFilter',
	pure: false
})
export class StringFilterPipe implements PipeTransform {
	transform(stringArray: string[], stringsToFilter: string[]) {
		return stringArray.filter((str) => stringsToFilter.indexOf(str) === -1);
	}
}
